export default "__VITE_ASSET__DD0W8FE$__"